// ** Type import
import { VerticalNavItemsType } from 'src/@core/layouts/types'

const navigation = (): VerticalNavItemsType => {
  return [
    {
      title: 'Inicio',
      path: '/home',
      icon: 'mdi:home-outline'
    },
    {
      title: 'Solicitudes',
      path: '/solicitudes',
      icon: 'mdi:chart-bar'
    },
    {
      title: 'Mis Datos',
      path: '/mis-datos',
      icon: 'mdi:fingerprint'
    },
    {
      title: 'Documentacion',
      path: '/documentacion',
      icon: 'mdi:file-document-outline'
    },
    {
      title: 'Comerciales',
      path: '/comerciales',
      icon: 'mdi:account-box'
    },
    {
      title: 'Notificaciones',
      path: '/notificaciones',
      icon: 'mdi:bell-outline'
    }
    
      /*
      
        {
            title: 'Ayuda',
            path: '/home',
            icon: 'mdi:help-circle'
        }
       */
  ]
}

export default navigation
